<template>
  <div>
    <!-- Full name -->
        <b-form-group
        label="Full Name"
      >
        <b-form-input
          :value="section.dependantFullname"
          @input="handleInput('dependantDetails', $event, false, true, index, `dependantFullname`)"
          :class="{
            'is-valid': !$v.section.dependantFullname.$error && section.dependantFullname,
            'is-invalid': $v.section.dependantFullname.$error 
          }"
        >

        </b-form-input>

      </b-form-group>
      <!-- DOB -->
      <b-form-group
        label="Relationship"
      >
        <b-form-input
           :value="section.dependantRelationship"
          @input="handleInput('dependantDetails', $event, false, true, index, `dependantRelationship`)"
          :class="{
            'is-valid': !$v.section.dependantRelationship.$error && section.dependantRelationship,
            'is-invalid': $v.section.dependantRelationship.$error 
          }"
        >

        </b-form-input>

      </b-form-group>
  </div>
</template>

<script>

import { mapActions, mapState, mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { updateForm } from '../../../helpers/index'
export default {
   props: ['index', 'section'],
   computed: {
      ...mapGetters({
        getRecruit: 'authStore/getRecruit'
      }),
     ...mapState({form: state => state.authStore.recruit.onboarding.onboardingForms.detailsForm}),
  },
  data () {
    return {
      referer: window.siteVar.referer,
      formName: 'detailsForm'
    }
  },
  mounted () {
    this.$v.$touch()
  },
   methods: {
     ...mapActions({
      selectAddressAction: 'authStore/selectAddressAction',
      updateOnboardingFormAction: 'authStore/updateOnboardingFormAction',
      currentOnboardingFormAction: 'authStore/currentOnboardingFormAction',
      setRecruitAction: 'authStore/setRecruitAction',
      createNextOfKinAction: 'authStore/createNextOfKinAction',
      removeNextOfKinAction: 'authStore/removeNextOfKinAction'

    }),
    handleInput(input, e, nested, array, index, item) {
      this.updateForm(input, e, nested, array, index, item)
    },
     updateForm
   },
   validations: {
    section: {
      dependantFullname: {
        required: required
      },
      dependantRelationship: {
        required: required
      }
    }
  }
}
</script>

<style scoped>

</style>
